export default __webpack_public_path__ + "static/media/15.0ec89d76.png";